import { Box, Modal } from '@palmetto/palmetto-components';

import { AccountDocument, incentiveStatusLabels } from 'types';

import DateTimeDisplay from '../DateTime';

interface IncentivesHistoryModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  account: AccountDocument | null;
}

export function IncentivesHistoryModal({ isOpen, onDismiss, account }: IncentivesHistoryModalProps) {
  const incentivesHistory = account?.incentiveAllocations?.history || [];
  return (
    <Modal ariaLabelledBy="incentivesHistoryModal" isOpen={isOpen} onDismiss={onDismiss} maxWidth="700px">
      <Modal.Header
        id="incentivesHistoryModal"
        title={`Incentives History (${incentivesHistory.length})`}
        onDismiss={onDismiss}
      />
      <Modal.Body childGap="lg" background="secondary">
        {incentivesHistory.length === 0 ? (
          <Box padding="lg" textAlign="center" color="grey-500">
            No incentives history available
          </Box>
        ) : (
          incentivesHistory.map((entry, index) => (
            <Box key={`${entry.allocationName}-${entry.incentiveType}-${entry.dateAssigned?.toString()}-${index}`}>
              <Box childGap="sm">
                <Box color="grey-500" fontSize="md" fontWeight="bold">
                  Allocation {index + 1}: {entry.allocationName} | Incentive type :{' '}
                  {entry.incentiveType.toUpperCase()}
                </Box>
                <Box padding="0 0 0 md">
                  <Box fontSize="sm" margin="0 0 xs 0">
                    <Box fontWeight="bold" display="inline">
                      Allocation:{' '}
                    </Box>
                    {entry.allocationName ? entry.allocationName : '---'}
                  </Box>
                  <Box fontSize="sm" margin="0 0 sm 0">
                    <Box fontWeight="bold" display="inline">
                      Status:{' '}
                    </Box>
                    {entry.status ? incentiveStatusLabels[entry.status] : '---'}
                  </Box>
                  {entry.blockDate && (
                    <Box fontSize="sm" margin="0 0 sm 0">
                      <Box fontWeight="bold" display="inline">
                        Block Date:{' '}
                      </Box>
                      {entry?.blockDate ? (
                        <DateTimeDisplay value={entry?.blockDate?.toString()} dateFormat={'DD'} excludeTime />
                      ) : (
                        '---'
                      )}
                    </Box>
                  )}
                  {entry.blockReason && (
                    <Box fontSize="sm" margin="0 0 sm 0">
                      <Box fontWeight="bold" display="inline">
                        Block Reason:{' '}
                      </Box>
                      {entry.blockReason ? entry.blockReason : '---'}
                    </Box>
                  )}
                  <Box display="flex" gap="md" fontSize="sm">
                    <Box>
                      <Box fontWeight="bold" color="grey-500" fontSize="sm" margin="0 0 2xs 0">
                        Assigned Date:
                      </Box>
                      <Box color="grey-800">
                        {entry?.dateAssigned ? (
                          <DateTimeDisplay value={entry?.dateAssigned?.toString()} dateFormat={'DD'} excludeTime />
                        ) : (
                          '---'
                        )}
                      </Box>
                    </Box>
                    <Box>
                      <Box fontWeight="bold" color="grey-500" fontSize="sm" margin="0 0 2xs 0">
                        Removed Date:
                      </Box>
                      <Box color="grey-800">
                        {entry?.dateRemoved ? (
                          <DateTimeDisplay value={entry?.dateRemoved?.toString()} dateFormat={'DD'} excludeTime />
                        ) : (
                          '---'
                        )}
                      </Box>
                    </Box>
                    <Box>
                      <Box fontWeight="bold" color="grey-500" fontSize="sm" margin="0 0 2xs 0">
                        Removal Reason:
                      </Box>
                      <Box color="grey-800">{entry.endReason ? entry.endReason : '---'}</Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              {index < incentivesHistory.length - 1 && <Box height="1px" background="grey-200" margin="lg 0" />}
            </Box>
          ))
        )}
      </Modal.Body>
    </Modal>
  );
}
